/* src/app/views/template/components/templates/digital/digital-template-collections/digital-template-collections.component.scss */
/*# sourceMappingURL=digital-template-collections.component.css.map */
